export const code = axios => ({
	// 코드 전체 조회
	fetchAllCodes(params) {
		return axios.get('/api/retailer/codes/', { params });
	},
});
